import { AuthenticationService } from './../../@core/auth/authentication.service';
import { Credentials } from './../../@core/models/login-models';
import { ContactoComponent } from './../dialogs/contacto/contacto.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CredentialsService } from './../../@core/auth/credentials.service';
import { LOGIN, USERS_CHANGE_PASSWORD } from '@app/@core/constants/routes.constants';
import { HeaderService } from './header.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Output() toggleSidenav = new EventEmitter<boolean>();
  showMenu: boolean;
  username: string;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private changePasswordService: HeaderService,
    private authenticationService: AuthenticationService,
    private credentialsService: CredentialsService
  ) {
    this.showMenu = false;

    const fullName = this.credentialsService.credentials.username.split('');
    this.username = (fullName.shift().charAt(0) + fullName.pop().charAt(0)).toUpperCase();
  }

  opened: boolean;
  toggleMenu() {
    this.toggleSidenav.emit(this.showMenu);
  }

  ngOnInit() {}

  logout() {
    this.authenticationService.logout().subscribe(
      () => {
        this.logoutUser();
      },
      (error) => {
        console.log(error);
        this.logoutUser();
      }
    );
  }

  logoutUser() {
    this.authenticationService.stopRefreshTokenTimer();
    this.router.navigate([LOGIN], { replaceUrl: true });
    this.credentialsService.setCredentials();
  }

  changePassword() {
    this.changePasswordService.setChangePassword(true);
    this.router.navigate([USERS_CHANGE_PASSWORD], { replaceUrl: true });
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '700px';

    const modalDialog = this.dialog.open(ContactoComponent, dialogConfig);
  }
}
